import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/index.css";
import App from "@/App";
import EmergencyPortal from "@/EmergencyPortal";
import PublicLayout from "@/PublicSite/PublicLayout";
import Home from "@/PublicSite/Home";
import About from "@/PublicSite/About";
import OurWork from "@/PublicSite/OurWork";
import SuccessStories from "@/PublicSite/SuccessStories";
import HowToHelp from "@/PublicSite/HowToHelp";
import Contact from "@/PublicSite/Contact";
import Services from "@/PublicSite/Services";
import Brochure from "@/PublicSite/Brochure";
import Capabilities from "@/PublicSite/Capabilities";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        {/* Public Website Routes */}
        <Route path="/" element={<PublicLayout />}>
          <Route index element={<Home />} />
          <Route path="about" element={<About />} />
          <Route path="our-work" element={<OurWork />} />
          <Route path="ai-services" element={<Services />} />
          <Route path="ai-services/brochure" element={<Brochure />} />
          <Route path="ai-services/capabilities" element={<Capabilities />} />
          <Route path="success-stories" element={<SuccessStories />} />
          <Route path="how-to-help" element={<HowToHelp />} />
          <Route path="contact" element={<Contact />} />
        </Route>
        
        {/* Emergency Portal (Public) */}
        <Route path="/rescue" element={<EmergencyPortal />} />
        
        {/* Sanctuary App (Private - requires login) */}
        <Route path="/app/*" element={<App />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>,
);
